import { render } from "./btn-close.vue?vue&type=template&id=a384c31c"
import script from "./btn-close.vue?vue&type=script&lang=js"
export * from "./btn-close.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__